<template>
  <div class="px-3 px-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 rounded-2 bg-white py-4 w-100">
      <div></div>
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-end gap-2 w-100">
        <DateRangePicker :id="id" @update:date="handleRangeDate" />
        <ButtonDropdownFilter
            :search="false"
            :options="Object.values(status)"
            value-field="value"
            :name-field="locale"
            v-model="query.status"
        />
        <ButtonDropdownFilter
            :options="Object.values(contactList)"
            value-field="id"
            name-field="fullname"
            v-model="query.contact"
        />
      </div>
  </div>
</template>
<script setup>
import DateRangePicker from "@/components/DateRangePicker.vue";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import { useLocales } from "@/composables/locales";
import {computed} from "vue";
import i18n from "@/plugins/i18n";

const {locale} = useLocales()

const props = defineProps({
  handleRangeDate: {type: Function, default: () => {}},
  contacts: { type: Object, default:  {}},
  status: { type: Object, default:  {}},
  id: {type: String, default: 'kt_td_picker_button'},
  query: {type: Object, default: {startDate: '',endDate: '',search: '',status: '',contact: ''}}
})

const contactList = computed(() => {
  return [{ id: 'all', fullname: i18n.global.t('label.allContacts') }, ...props.contacts];
});

</script>
<style scoped>
  @import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.min.css";
</style>
